import { render, staticRenderFns } from "./WidgetsHandler.vue?vue&type=template&id=fc0cd32a&scoped=true&"
import script from "./WidgetsHandler.vue?vue&type=script&lang=js&"
export * from "./WidgetsHandler.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsHandler.vue?vue&type=style&index=0&id=fc0cd32a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0cd32a",
  null
  
)

export default component.exports